import { tournamentsTabs } from './options';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/lib/store';
import { useCallback } from 'react';
import { setCurrentTournamentTab } from '@/lib/store/tournaments/actions';
import { Nullable } from '@starsoft/common/interfaces';
import { TournamentStatus } from '@/models/tournament/status';
import { TabsWithVersion } from '@/components/core/TabsWithVersion';

export default function TournamentsPageTabs() {
  const dispatch = useDispatch();
  const currentTab = useSelector((state: RootState) => state.tournaments.tab);

  const onTabChange = useCallback(
    (e: Nullable<TournamentStatus>) => {
      dispatch(setCurrentTournamentTab(e));
    },
    [dispatch],
  );

  return (
    <TabsWithVersion
      i18nNamespace="tournaments"
      tabs={tournamentsTabs}
      currentTab={currentTab}
      setTab={onTabChange}
      useMaxContent
    />
  );
}
